var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"intersected",rawName:"v-intersected",value:(_vm.lazyLoad),expression:"lazyLoad"}],style:({opacity: _vm.loaded ? 1 : 0}),attrs:{"src":_vm.imageSrc,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }